export default "__VITE_ASSET__989b89b4__"